export const formatCreatedAt = (isoString?: string, options = {}): string => {
  if (isoString) {
    const date = new Date(isoString);

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
      ...options
    }).format(date);
  } else {
    return "";
  }
};
